import { updateFormDataSet, getFormDataSetFieldValue } from "./CrmFieldUtil"
import { PRIMARY_ADDRESS_FIELDS } from "./Constants"

export const applyClientConditionalValues = (value, name, infoFields, broker) => {
    if(broker == "SIGMA" || broker == "AXTELLA") {
        infoFields = applyValueIfNoTrustedContactForSigmaAndAxtella(value, name, infoFields)
        infoFields = applyValueIfUnemployedForAxtella(value, name, infoFields)
        infoFields = removeProductCompanyValueForAxtella(value, name, infoFields)
    }

    if(broker == "M_FINANCIAL") {
        infoFields = applyValueIfUnemployedForMFinancial(value, name, infoFields)
        infoFields = applyValueForSpecificNetWorthForMFinancial(value, name, infoFields)
        infoFields = applyValueForSpecificAnnualIncomeForMFinancial(value, name, infoFields)
        infoFields = applyValueForSourceOfFundsForMFinancial(value, name, infoFields)
    }

    return infoFields
}

export const applyAccountConditionalValues = (value, name, accountInfoFields, clientInfoFields, broker) => {
    accountInfoFields = applyPrimaryAddressIfSameAsEntityAddress(value, name, accountInfoFields, clientInfoFields)
    accountInfoFields = applyPrimaryAddressIfSameAsTrustAddress(value, name, accountInfoFields, clientInfoFields)

    if(broker == "SIGMA" || broker == "AXTELLA") {
        accountInfoFields = removeProductCompanyValueForAxtella(value, name, accountInfoFields)
        accountInfoFields = removeValueIfNoBankingInstructions(value, name, accountInfoFields)
    }

    return accountInfoFields
}

const applyValueIfNoTrustedContactForSigmaAndAxtella = (value, name, infoFields) => {
    let trustedNullableFields = [
        "Trusted Contact: Name",
        "Trusted Contact: Email Address",
        "Trusted Contact: Phone Number",
        "Trusted Contact: Address",
        "Trusted Contact: City",
        "Trusted Contact: Relationship to Client",
        "Trusted Contact: Zip"
    ]

    if(name === "Trusted Contact: Options" && value === "3") {
        trustedNullableFields.forEach(field => {
            infoFields = updateFormDataSet(null, field, infoFields)
        })
    }
    return infoFields
}

const applyValueIfUnemployedForMFinancial = (value, name, infoFields) => {
    let employmentNullableFields = [
        "Occupation",
        "Business Phone",
        "Employer Name",
        "Employer Address",
        "Employer City",
        "Employer State",
        "Employer Zip"
    ]

    if(name === "Employment Status" && value !== 1) {
        employmentNullableFields.forEach(field => {
            infoFields = updateFormDataSet(null, field, infoFields)
        })
    }
    return infoFields
}

const applyValueIfUnemployedForAxtella = (value, name, infoFields) => {
    let employmentNullableFields = [
        "Income Source",
        "Employer Name",
        "Employer Address",
        "Employer City",
        "Employer State",
        "Employer Zip",
        "Type of Business",
        "Occupation",
        "Years Employed",
        "Length of Employment (yrs)"
    ]

    if(name === "Employment Status" && value !== 1) {
        employmentNullableFields.forEach(field => {
            infoFields = updateFormDataSet(null, field, infoFields)
        })
    }
    return infoFields
}

const removeValueIfNoBankingInstructions = (value, name, accountInfoFields) => {
    let bankingInformationFields = [
        "Bank Account Type",
        "ABA Number",
        "Bank Account Number",
        "Name of Bank/Credit Union",
        "Name as it appears on the bank account",
        "First or third party standing payment instructions?",
        "Amount to Brokerage",
        "Amount to Bank",
        "Transaction Frequency",
        "Next Transaction Date",
        "Federal Taxes Withheld",
        "State Taxes Withheld"
    ]

    if(name === "Add banking instructions?" && value !== 1) {
        bankingInformationFields.forEach(field => {
            accountInfoFields = updateFormDataSet(null, field, accountInfoFields)
        })
    }
    return accountInfoFields
}

const removeProductCompanyValueForAxtella = (value, name, accountInfoFields) => {
    if(name === "Account Platform" && value !== "Direct") {
        accountInfoFields = updateFormDataSet(null, "Product Company", accountInfoFields)
    }
    return accountInfoFields
}

const applyValueForSpecificNetWorthForMFinancial = (value, name, infoFields) => {
    let networthField = "Net Worth"

    if(name === networthField && value !== "1") {
        infoFields = updateFormDataSet(null, "Net Worth Over $2,500,000", infoFields)
    }

    if(name === networthField && value !== "6") {
        infoFields = updateFormDataSet(null, "Net Worth Below $99,999", infoFields)
    }
    return infoFields
}

const applyValueForSpecificAnnualIncomeForMFinancial = (value, name, infoFields) => {
    let annualIncomeField = "Household Annual Income";

    if(name === annualIncomeField && value !== "1") {
        infoFields = updateFormDataSet(null, "Annual Income Over $2,500,000", infoFields)
    }

    if(name === annualIncomeField && value !== "6") {
        infoFields = updateFormDataSet(null, "Annual Income Below $99,999", infoFields)
    }
    return infoFields
}

const applyValueForSourceOfFundsForMFinancial = (value, name, infoFields) => {
    let sourceOfFundsField = "Original Source of Funds";

    if(name === sourceOfFundsField && value !== "6") {
        infoFields = updateFormDataSet(null, "Funds Inheritance/Gift From:", infoFields)
    }

    if(name === sourceOfFundsField && value !== "9") {
        infoFields = updateFormDataSet(null, "Funds Other:", infoFields)
    }

    return infoFields
}

export const applyPrimaryAddressIfSameAsEntityAddress = (value, name, accountInfoFields, clientInfoFields, broker) => {
    if(broker !== "SIGMA" && broker !== "AXTELLA") {
        return accountInfoFields
    }

    if(name === "Entity Address same as Primary Address?" && value === "Y") {
        let fieldToUpdate
        PRIMARY_ADDRESS_FIELDS.forEach(field => {
            if(field === "Primary Address") {
                fieldToUpdate = "Entity Address"
            } else if(field === "Primary City") {
                fieldToUpdate = "Entity City"
            } else if(field === "Primary State") {
                fieldToUpdate = "Entity State"
            } else if(field === "Primary Zip") {
                fieldToUpdate = "Entity Zip"
            }

            let entityFieldValue = getFormDataSetFieldValue(accountInfoFields, fieldToUpdate)
            let primaryFieldValue = getFormDataSetFieldValue(clientInfoFields, field)
            if(primaryFieldValue && (primaryFieldValue !== entityFieldValue)) {
                accountInfoFields = updateFormDataSet(primaryFieldValue, fieldToUpdate, accountInfoFields)
            }
        })

        return accountInfoFields
    }

    return accountInfoFields
}

export const applyPrimaryAddressIfSameAsTrustAddress = (value, name, accountInfoFields, clientInfoFields, broker) => {
    if(broker !== "SIGMA" && broker !== "AXTELLA") {
        return accountInfoFields
    }

    if(name === "Trust Address same as Primary Address?" && value === "Y") {
        let fieldToUpdate
        PRIMARY_ADDRESS_FIELDS.forEach(field => {
            if(field === "Primary Address") {
                fieldToUpdate = "Trust Address"
            } else if(field === "Primary City") {
                fieldToUpdate = "Trust City"
            } else if(field === "Primary State") {
                fieldToUpdate = "Trust State"
            } else if(field === "Primary Zip") {
                fieldToUpdate = "Trust Zip"
            }

            let trustFieldValue = getFormDataSetFieldValue(accountInfoFields, fieldToUpdate)
            let primaryFieldValue = getFormDataSetFieldValue(clientInfoFields, field)
            if(primaryFieldValue && (primaryFieldValue !== trustFieldValue)) {
                accountInfoFields = updateFormDataSet(primaryFieldValue, fieldToUpdate, accountInfoFields)
            }
        })

        return accountInfoFields
    }

    return accountInfoFields
}